import { defineStore } from 'pinia'
import apiFetch from '@wordpress/api-fetch'

export const useCountriesStore = defineStore('countries', {
  state: () => ({
    countries: [],
    activeCountries: [],
  }),

  actions: {
    loadCountries(params = {}) {
      this.countries = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      return apiFetch({
        path: `/wp-json/ebus/market/countries?${query.toString()}`,
      }).then((data) => {
        this.countries = data;

        return data;
      }).catch((error) => {
        console.log('Error: ', error);
      });
    },

    toggleCountry(countryCode) {
      const index = this.activeCountries.indexOf(countryCode);

      if (index === -1) {
        this.activeCountries.push(countryCode);
      } else {
        this.activeCountries.splice(index, 1);
      }
    },

    resetActiveCountries() {
      this.activeCountries = [];
    },
  },
})
